import type { ComponentTheme } from '../types/component-theme';

import { ThemeVariants } from './constants/theme-variants';

export default {
    slots: {
        root: 'flex justify-center',
        message: 'flex items-center justify-center gap-1.5 rounded-xl border px-4 py-3 text-center'
    },
    variants: {
        theme: {
            [ThemeVariants.Dark]: {
                message:
                    'border-white/10 bg-white/5 text-slate-200 ' +
                    'shadow-[0_0.5rem_1.5rem_rgba(0,0,0,0.35),0_0.125rem_0.5rem_rgba(0,0,0,0.2),inset_0_0.063rem_0_rgba(255,255,255,0.08)]'
            },
            [ThemeVariants.Light]: {
                message:
                    'border-slate-200 bg-white/80 text-slate-700 ' +
                    'shadow-[0_0.5rem_1.5rem_rgba(100,116,139,0.18),0_0.125rem_0.5rem_rgba(100,116,139,0.12),inset_0_0.063rem_0_rgba(255,255,255,0.8)]'
            }
        }
    }
} satisfies ComponentTheme;
